import { ref } from 'vue';
import { commonapi } from '@/apis/spot';

export const useUtcTime = () => {
    let timer = null;
    // 本地时间
    let localTime = Date.now();
    // 服务器时间
    const serverTime = ref(0);
    // 时间差
    const diffTime = ref(0);
    // 方法集合
    const methods = {
        // 获取服务器时间
        getUtcTime: async () => {
            const { result } = await commonapi.getUtcTs();
            if (result) {
                localTime = Date.now();
                diffTime.value = result - localTime;
                serverTime.value = result;
                methods.startTimeWatch();
            }
        },
        // 时间监控,防止修改本地时间
        startTimeWatch: () => {
            if (timer) clearTimeout(timer);
            const now = Date.now();
            if (Math.abs(now - localTime) > 7000) {
                methods.getUtcTime();
            }
            localTime = now;
            timer = setTimeout(methods.startTimeWatch, 5000);
        },
    };
    if (!serverTime.value) {
        methods.getUtcTime();
    }
    return {
        serverTime,
        diffTime,
    };
};
